import dynamic from "next/dynamic";

import AppleTV from "@/icons/__generated__/AppleTV/AppleTv16";
import Blinds from "@/icons/__generated__/Blinds/Blinds16";
import BreakoutRoom from "@/icons/__generated__/BreakoutRoom/BreakoutRoom24";
import Chalkboard from "@/icons/__generated__/Chalkboard/Chalkboard24";
import CleaningSupplies from "@/icons/__generated__/CleaningSupplies/CleaningSupplies16";
import ElectricalPlug from "@/icons/__generated__/ElectricalPlug/ElectricalPlug24";
import Handicap from "@/icons/__generated__/Handicap/Handicap16";
import Light from "@/icons/__generated__/Light/Light24";
import Lightbulb from "@/icons/__generated__/Lightbulb/Lightbulb16";
import Mic from "@/icons/__generated__/Mic/Mic24";
import Mobile from "@/icons/__generated__/Mobile/Mobile16";
import PublicTransportation from "@/icons/__generated__/PublicTransportation/PublicTransportation16";
import Rooftop from "@/icons/__generated__/Rooftop/Rooftop16";
import Soundboard from "@/icons/__generated__/Soundboard/Soundboard16";
import ToiletPaper from "@/icons/__generated__/ToiletPaper/ToiletPaper16";
import Utensils from "@/icons/__generated__/Utensils/Utensils16";
import Wardrobe from "@/icons/__generated__/Wardrobe/Wardrobe16";

const iconCache: Record<string, React.ComponentType<unknown>> = {};

export const loadDynamicIcon = (iconName: string, size = 24) => {
  const cacheKey = `${iconName}-${size}`;

  if (!iconCache[cacheKey]) {
    let iconNameImportFormat = iconName
      .split(/[-_]/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join("");

    if (iconName === "rules") {
      iconNameImportFormat = "DocLines";
    } else if (iconName === "flipboard") {
      iconNameImportFormat = "FlipChart";
    } else if (iconName === "chalkboard") {
      return Chalkboard;
    } else if (iconName === "conference_phone") {
      return Mobile;
    } else if (iconName === "apple_tv") {
      return AppleTV;
    } else if (iconName === "toilet") {
      return ToiletPaper;
    } else if (iconName === "breakout_room") {
      return BreakoutRoom;
    } else if (iconName === "handicap_access") {
      return Handicap;
    } else if (iconName === "roof_outdoors") {
      return Rooftop;
    } else if (iconName === "electrical") {
      return ElectricalPlug;
    } else if (iconName === "lighting") {
      return Light;
    } else if (iconName === "sound") {
      return Mic;
    } else if (iconName === "public_transit") {
      return PublicTransportation;
    } else if (iconName === "lightbulb_icon") {
      return Lightbulb;
    } else if (iconName === "wardroberack") {
      return Wardrobe;
    } else if (iconName === "blinds") {
      return Blinds;
    } else if (iconName === "utensils_plates") {
      return Utensils;
    } else if (iconName === "janitorial_services") {
      return CleaningSupplies;
    } else if (iconName === "avtechnician") {
      return Soundboard;
    }

    try {
      iconCache[cacheKey] = dynamic(
        () =>
          import(
            `@/icons/__generated__/${iconNameImportFormat}/${iconNameImportFormat}${size}`
          ).catch(() => {
            return { default: () => null };
          }),
        {
          loading: () => null,
          ssr: false,
        },
      );
    } catch {
      return null;
    }
  }

  return iconCache[cacheKey];
};
